export default "__VITE_ASSET__b3d9372f__"